module.exports = __webpack_public_path__ + "static/media/burger.dd4dd6bf.png";